import { Grid } from "@mantine/core";
import {
    AlertTriangle,
    Clock,
    DollarSign,
    Phone,
    PhoneCall,
    Timer,
    TrendingUp,
    Users
} from "lucide-react";
import { default as React } from 'react';
import { MetricCard } from "./metric_card";
import { useLanguage } from "../../contexts/language.context";

export default function Metrics({ values = [], workspaces = {} }: { workspaces: any; values: { label: string; value: string; }[] }) {
    const { str } = useLanguage();

    const existsValue = (label: string): boolean => values.some((v) => v.label === label);
    const getValue = (label: string): string => values.find((v) => v.label === label)?.value ?? "";

    return <>
        <Grid>
            <Grid.Col span={{ md: 3 }}>
                <MetricCard
                    title={str("REPORTS.TOTAL_CALLS")}
                    value={getValue("Total Calls")}
                    changeType="positive"
                    icon={<Phone className="h-5 w-5" />}
                    gradient
                />
            </Grid.Col>
            <Grid.Col span={{ md: 3 }}>
                <MetricCard
                    title={str("REPORTS.AVERAGE_DURATION")}
                    value={getValue("Average Duration")}
                    changeType="negative"
                    icon={<Clock className="h-5 w-5" />}
                />
            </Grid.Col>
            <Grid.Col span={{ md: 3 }}>
                <MetricCard
                    title={existsValue("Total Cost") ? str("REPORTS.TOTAL_COST") : str("REPORTS.TOTAL_OUTCOMES")}
                    value={existsValue("Total Cost") ? getValue("Total Cost") : getValue("Total Outcomes")}
                    changeType="positive"
                    icon={<DollarSign className="h-5 w-5" />}
                />
            </Grid.Col>
            <Grid.Col span={{ md: 3 }}>
                <MetricCard
                    title={str("REPORTS.SUCCESS_RATE")}
                    value={getValue("Success Rate")}
                    changeType="positive"
                    icon={<TrendingUp className="h-5 w-5" />}
                />
            </Grid.Col>
        </Grid>

        <Grid>
            <Grid.Col span={{ md: 3 }}>
                <MetricCard
                    title={str("REPORTS.ACTIVE_WORKSPACES")}
                    value={`${workspaces.actives ?? 0} / ${workspaces?.total ?? 0}`}
                    icon={<Users className="h-5 w-5" />}
                />
            </Grid.Col>
            <Grid.Col span={{ md: 3 }}>
                <MetricCard
                    title={str("REPORTS.ANSWERED_CALLS")}
                    value={getValue("Answered Calls")}
                    changeType="positive"
                    icon={<PhoneCall className="h-5 w-5" />}
                />
            </Grid.Col>
            <Grid.Col span={{ md: 3 }}>
                <MetricCard
                    title={existsValue("Average Cost") ? str("REPORTS.AVERAGE_COST") : str("REPORTS.AVERAGE_OUTCOMES")}
                    value={existsValue("Average Cost") ? getValue("Average Cost") : getValue("Average Outcomes")}
                    changeType="neutral"
                    icon={<Timer className="h-5 w-5" />}
                />
            </Grid.Col>
            <Grid.Col span={{ md: 3 }}>
                <MetricCard
                    title={str("REPORTS.FAILED_CALLS")}
                    value={getValue("Failed Calls")}
                    changeType="negative"
                    icon={<AlertTriangle className="h-5 w-5" />}
                />
            </Grid.Col>
        </Grid>
    </>
}